import { Article, Aside, ContentLayout } from '../../common/ContentLayout/ContentLayout';

import styles from './SellerAcceptanceAboveReserveExperiment.module.scss';

export const SellerAcceptanceAboveReserveExperiment = () => (
  <div className={styles.aboveReserveExperiment}>
    <ContentLayout>
      <Article>
        <h1>Seller Acceptance Above Reserve Experiment</h1>
      </Article>
      <Aside>
        <p>Seller Acceptance Above Reserve Experiment Aside</p>
      </Aside>
    </ContentLayout>
  </div>
);
